import { PostRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class DeletePostUseCase {
  constructor(private postRepository: PostRepository) {}

  async execute(postId: string, userId: string): Promise<void> {
    logger.debug('DeletePost', 'Deleting post', { postId, userId });

    // Get post to verify ownership
    const post = await this.postRepository.getById(postId);

    if (!post) {
      throw new Error('Post not found');
    }

    if (post.userId !== userId) {
      throw new Error('You can only delete your own posts');
    }

    await this.postRepository.delete(postId);

    logger.debug('DeletePost', 'Successfully deleted post');
  }
}
